import {
  Autocomplete as MuiAutocomplete,
  AutocompleteProps as MuiAutocompleteProps,
  Popper,
  styled,
} from "@mui/material";
import { autocompleteClasses } from "@mui/material/Autocomplete";

type AutocompleteProps<
  Value = any,
  Multiple extends boolean | undefined = boolean | undefined,
  DisableClearable extends boolean | undefined = boolean | undefined,
  FreeSolo extends boolean | undefined = boolean | undefined,
  ChipComponent extends React.ElementType<any> = React.ElementType<any>,
> = MuiAutocompleteProps<Value, Multiple, DisableClearable, FreeSolo, ChipComponent>;

const StyledAutocomplete = styled(MuiAutocomplete)(() => {
  return {
    "& .MuiOutlinedInput-root": {
      "flex-wrap": "nowrap",
    },
    "& .MuiInputAdornment-root": {
      minWidth: "45%",
      height: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "block",
    },
  };
});

const StyledPopper = styled(Popper)(({ theme }) => ({
  [`& .${autocompleteClasses.option}`]: {
    paddingLeft: `${theme.spacing(2)} !important`,
    fontWeight: 600,
    backgroundColor: theme.palette.background.paper,
    minHeight: `${theme.spacing(6)} !important`,
  },

  [`&& .${autocompleteClasses.groupLabel}`]: {
    lineHeight: `${theme.spacing(5)}`,
  },
}));

export const Autocomplete: React.FC<AutocompleteProps> = (props) => {
  return <StyledAutocomplete PopperComponent={StyledPopper} {...props} />;
};

export default Autocomplete;
